import { createSlice } from '@reduxjs/toolkit';
import type { fleetData } from 'types/production.types';

export interface productionState {
  data: {
    allFleet: fleetData;
  };
  loadingStates: {
    isLoadingFleetAssets: boolean;
    isLoadingFleetSummary: boolean;
    isLoadingFleetDetails: boolean;
    isLoadingFleetPeriodSummary: boolean;
  };
}

const initialState: productionState = {
  data: {
    allFleet: {
      assets: [],
      summary: {
        period: 'current',
        cycle_time: 0,
        cycle_time_percentage_diff: 0,
        total_load: 0,
        total_load_percentage_diff: 0,
        avgTonDay: 0,
        avgTonDay_percentage_diff: 0,
        avgTon: 0,
        avgTon_percentage_diff: 0,
        haul_truck_cycle_time: 0,
        haul_truck_cycle_time_percentage_diff: 0,
        haul_truck_travel_empty: 0,
        haul_truck_travel_empty_percentage_diff: 0,
        haul_truck_dump: 0,
        haul_truck_dump_percentage_diff: 0,
        haul_truck_loading_duration: 0,
        haul_truck_loading_duration_percentage_diff: 0,
        haul_truck_loaded_stop: 0,
        haul_truck_loaded_stop_percentage_diff: 0,
        haul_truck_travel_loaded: 0,
        haul_truck_travel_loaded_percentage_diff: 0,
        loader_cycle_time: 0,
        loader_travel_empty: 0,
        loader_dump: 0,
        loader_loading_duration: 0,
        loader_loaded_stop: 0,
        loader_travel_loaded: 0,
        cycle_count: 0,
        cycle_count_percentage_diff: 0,
      },
      totalFleetDetails: {
        tons: 0,
        dailyAverageTon: 0,
        cycleTime: 0,
        ytdTarget: 0,
        annualTarget: 0,
        rollingDailyAverage: 0,
        remainingDays: 0,
      },
      fleetPeriodSummary: [],
    },
  },
  loadingStates: {
    isLoadingFleetAssets: true,
    isLoadingFleetSummary: true,
    isLoadingFleetDetails: true,
    isLoadingFleetPeriodSummary: true,
  },
};

export const productionSlice = createSlice({
  name: 'production',
  initialState,
  reducers: {
    setTotalFleetAssets(state, { payload }) {
      state.data.allFleet.assets = payload;
    },
    setTotalFleetSummary(state, { payload }) {
      state.data.allFleet.summary = {
        ...state.data.allFleet.summary,
        ...payload.summary,
      };
    },
    setTotalFleetDetails(state, { payload }) {
      state.data.allFleet.totalFleetDetails = {
        ...state.data.allFleet.totalFleetDetails,
        ...payload,
      };
    },
    setFleetPeriodSummary(state, { payload }) {
      state.data.allFleet.fleetPeriodSummary = payload;
    },
    setIsLoading(state, { payload }) {
      state.loadingStates = {
        ...state.loadingStates,
        ...payload,
      };
    },
  },
});

export const {
  setTotalFleetAssets,
  setTotalFleetSummary,
  setTotalFleetDetails,
  setIsLoading,
  setFleetPeriodSummary,
} = productionSlice.actions;
export default productionSlice.reducer;
